export const APOLLO_INTERNAL_STATE = '__APOLLO_STATE__'

export const APOLLO_INTERNAL_CSR_URI = '__APOLLO_CSR_URI__'
